'use client';
import Script from 'next/script';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { AdTags } from '@/app_lib/services/ads/defaults';

const fortuneTag = '5509364224622592';
const healthEvergreenTag = '5812722290393088';
export const OptimizelyScript = () => {
  const { pageAdConfig } = useAdContext();
  const isHealthEvergreen = pageAdConfig?.tags?.some((tag) => tag === AdTags.HealthEvergreenAb);
  if (pageAdConfig) {
    return (
      <Script
        id='optimizely-script-fortune'
        src={`https://cdn.optimizely.com/js/${isHealthEvergreen ? healthEvergreenTag : fortuneTag}.js`}
        strategy='afterInteractive'
      />
    );
  }
  return <></>;
};
